"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "curtarolo": {
    "4b01ebb4": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "skipSearch": false
    }],
    "giarona": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a6dc98a": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "skipSearch": false
    }],
    "palazzina": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4ff789ad": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "skipSearch": false
    }],
    "poncia": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f651f3c": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "skipSearch": false
    }],
    "tessara": [{
      "hkey": "1a522447",
      "slug": "curtarolo",
      "name": "Curtarolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;